export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
  keywords: string[];
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "FIFA官方购票",
    slug: "fifa-official",
    description: "通过国际足联官方渠道购买世界杯门票，最安全、最可靠的购票方式",
    icon: "ri-shield-check-line",
    articleCount: 8,
    keywords: ["FIFA官网", "官方渠道", "抽签购票", "先到先得", "官方转售平台"]
  },
  {
    id: "cat-2",
    name: "授权代理商",
    slug: "authorized-agents",
    description: "官方授权的票务代理机构，提供中文服务与本地化支持",
    icon: "ri-store-2-line",
    articleCount: 6,
    keywords: ["授权代理", "中国区代理", "票务代理", "旅行社", "官方合作伙伴"]
  },
  {
    id: "cat-3",
    name: "球迷套餐",
    slug: "fan-packages",
    description: "包含门票、住宿、交通等一站式球迷观赛套餐",
    icon: "ri-vip-crown-line",
    articleCount: 5,
    keywords: ["球迷套餐", "观赛套餐", "住宿门票", "旅行套餐", "款待套餐"]
  },
  {
    id: "cat-4",
    name: "抢票攻略",
    slug: "ticket-tips",
    description: "全面解析抢票技巧、时间节点与申请策略",
    icon: "ri-flashlight-line",
    articleCount: 7,
    keywords: ["抢票技巧", "申请攻略", "时间节点", "成功率", "多账号策略"]
  },
  {
    id: "cat-5",
    name: "避坑指南",
    slug: "scam-avoidance",
    description: "识别假票、黄牛陷阱，保护自己的合法权益",
    icon: "ri-alert-line",
    articleCount: 6,
    keywords: ["假票识别", "黄牛陷阱", "安全购票", "防骗指南", "验票方法"]
  }
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find(c => c.slug === slug);
};